import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@pesto/ui/components/Sheet';
import { cn } from '@pesto/utils';
import * as React from 'react';

interface DebuggerDrawerProps {
  className?: string;
  open: boolean;
  onClose: (value: boolean) => void;
  children: React.ReactNode;
}

export const DebuggerDrawer = ({ className, open, onClose, children }: DebuggerDrawerProps) => {
  const handleClose = () => onClose(false);

  return (
    <Sheet open={open} onOpenChange={handleClose}>
      <SheetContent className={cn('w-full max-w-md', className)}>
        <SheetHeader className="flex items-center justify-between border-b px-4 py-3">
          <SheetTitle className="text-foreground font-semibold leading-6">Admin Debugger</SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto p-4">{children}</div>
      </SheetContent>
    </Sheet>
  );
};
